import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {loadScript} from './loadScript';
import pkg from './source.json';

// tslint:disable-next-line:no-namespace
declare namespace unlayer {
  function init(object);

  function createEditor(object);

  function loadDesign(object);

  function saveDesign(Function);

  function exportHtml(Function);
}

export interface UnlayerOptions {
  projectId?: number;
  tools?: object;
  appearance?: object;
  locale?: string;
}

let lastEditorId = 0;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'email-editor',
  templateUrl: './email-editor.component.html',
  styleUrls: ['./email-editor.component.css'],
  standalone: false,
})
export class EmailEditorComponent implements OnInit, AfterViewInit {
  id: any;

  @Input() projectId: number;
  @Input() displayMode: 'web' | 'email' = 'web';
  @Input() locale: string;
  @Input() dockSide: 'left' | 'right' = 'left';
  @Input() theme: 'dark' | 'light' = 'light';
  @Input() preview: boolean = false;
  @Input() stockImages: any = false;

  @Input() minHeight = '800px';

  @Input()
  user: string;
  @Input()
  signature: string;

  @Output() loaded = new EventEmitter();

  editor: any;

  constructor() {
    this.id = `editor-${++lastEditorId}`;
  }

  ngOnInit() {}

  ngAfterViewInit() {
    loadScript(this.loadEditor.bind(this));
  }

  protected loadEditor() {
    unlayer.init({
      id: this.id,
      projectId: this.projectId,
      displayMode: this.displayMode,
      locale: this.locale,
      appearance: {
        theme: this.theme,
        panels: {
          tools: {
            dock: this.dockSide,
          },
        },
      },
      features: {
        preview: this.preview,
        stockImages: this.stockImages,
      },
      source: {
        name: pkg.name,
        version: pkg.version,
      },
      user: {
        id: this.user,
        signature: this.signature,
      },
    });
    this.editor = unlayer;
    this.loaded.emit(this.editor);
  }

  public loadDesign(data: object) {
    this.editor.loadDesign(data);
  }

  public saveDesign(cb: (data: object) => void) {
    this.editor.saveDesign(cb);
  }

  public exportHtml(cb: (data: object) => void) {
    this.editor.exportHtml(cb);
  }
}
